var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTruck = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M14.27 3.5c.2 0 .37.15.4.34l.01.07v2.47h3.58c.11 0 .22.05.3.13l.04.05.04.06 1.33 3.05.03.16v4.58c0 .2-.15.37-.34.4l-.07.01h-1.86c-.09.68-.54 1.27-1.18 1.53a1.96 1.96 0 0 1-2.68-1.53H5.73a1.95 1.95 0 0 1-3.86 0H.41a.41.41 0 0 1-.4-.34L0 14.41V3.91c0-.2.15-.37.34-.4L.4 3.5h13.86zm3.37 4.44h-2.67v1.83h3.47z"
})));
export default SvgTruck;